
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".7","d":"M47.6 123.6c-3.4 2-6.4 3.2-9.6 3.2-8.3 0-15.2-6.8-15.6-14.9l16.1-9.6 25 11.2-15.9 10.1zM57.2 82.4l-12-5.3c-5.3-2.4-10.4-4.4-10.4-10.3 0-3.1.9-4.6 2.4-6.2l25.3 11.2-6.3 3.6c-1.7 1.1-2.9 2-2.9 3.3 0 1.5 1.7 2.7 3.9 3.7zM69 27.2l-12.3 7.4c-1.1.7-2.5 1.7-2.5 3.4 0 1.9 2.8 3.3 5.3 4.5l-15.3-6.8c-4.5-2-9-4.2-9-9.7 0-2.3.7-4.1 1.7-5.7L70.1 0c4 2.3 7.8 6.8 7.8 12.9 0 6.6-3.3 10.9-8.9 14.3zM95.1 51.2l-3 1.7-25.4-11.2L96.2 24c4 2.3 7.9 6.8 7.9 12.9 0 6.5-3.3 11-9 14.3zM73.7 72.7l15 6.6c5.6 2.5 7.3 5.5 7.3 9.2 0 2.1-1.2 4.2-2.9 5.7L67.9 83l4.3-2.4c3.6-2 4.8-3.2 4.8-4.5 0-1.4-.8-2.3-3.3-3.4z"}}),_c('path',{attrs:{"d":"M100.4 128c-6.4-4.9-13.2-8.2-21.4-12L40.8 99.1c-9.6-4.3-16-10-16-19.6 0-9.3 4.5-13.8 10.4-17.6l2.1-1.3c-1.5 1.6-2.4 3.2-2.4 6.2 0 5.9 5 7.9 10.4 10.3l44.5 19.6c7.7 3.3 14.8 9 14.8 18.8 0 5.3-2 10.1-4.2 12.5zM95.9 92.4l-2.8 1.8c1.7-1.5 2.9-3.6 2.9-5.7 0-3.7-1.7-6.7-7.3-9.2l-47.5-21c-9.6-4.2-15.6-9.7-15.6-19.3 0-8.8 4.4-14.5 11.3-18.8-1.1 1.6-1.7 3.4-1.7 5.7 0 5.4 4.5 7.7 9 9.7L90.4 56c8.4 3.7 15.2 9.3 15.2 19.6 0 8.1-3.7 13.1-9.7 16.8z"}})])
          )
        }
      }
    